import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "thought-item" }
const _hoisted_2 = { class: "thought-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "dialog-panel" }

import { computed, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  ...{
  name: "AppThought",
},
  __name: 'Thought',
  props: {
    title: {},
    subtitle: {},
    post: {},
    icon: {}
  },
  setup(__props: any) {



const props = __props;

const showDialog = ref(false);
const iconUrl = computed(() => require(`@/assets/icons/${props.icon}.svg`));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (iconUrl.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: iconUrl.value,
            alt: "icon",
            class: "thought-icon"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("strong", null, _toDisplayString(__props.title), 1),
        _createElementVNode("div", null, _toDisplayString(__props.subtitle), 1)
      ])
    ]),
    _createElementVNode("p", null, _toDisplayString(__props.post), 1),
    _createElementVNode("button", {
      type: "button",
      class: "primary-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = true))
    }, " Read more "),
    (showDialog.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "overlay",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showDialog.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
            _createElementVNode("p", null, _toDisplayString(__props.post), 1),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog.value = false))
            }, "Close")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})